<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="validation-main">
    <div class="content-container">
      <div class="left-container" resizable>
        <div class="filter-container" style="flex-grow: 1">
          <div style="font-weight: bold; margin-bottom: 2px; font-size: 0.85rem">Filter by Date</div>

          <div class="d-flex flex-column" style="margin-bottom: 8px">
            <div class="d-flex align-items-center">
              <DateTimePicker
                placeholder="From"
                style="height: auto; top: 0"
                :value.sync="selectedFromDate"
                :showTime="false"
                :errorMessage.sync="fromDateErr"
              />
            </div>
            <div class="d-flex align-items-center">
              <DateTimePicker
                placeholder="To"
                style="height: auto; top: 0"
                :value.sync="selectedToDate"
                :showTime="false"
                :errorMessage.sync="toDateErr"
              />
            </div>
          </div>

          <Button @click="validateClicked" :disabled="!dateRangeSelected" class="mb-1">Validate</Button>
        </div>
      </div>
      <div class="table-container">
        <TableBox
          title="Accounts Validation"
          :tableData="validationData"
          style="min-height: 0; min-width: 0"
          v-if="validationData"
          :lastRefreshed="lastRefreshed"
          :dataType="tableDataType"
          :hideColumns="validationHideColumns"
          :additionalButtons="[{ text: 'Open', index: 0, width: 60 }]"
          @buttonClicked="openClicked"
        />
        <div v-else style="max-width: 420px; text-align: center; font-size: 1.25rem; width: 100%">
          <span> Enter Date Filters and click on <b>Validate</b> to get started</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    dateRangeSelected: function () {
      return this.selectedFromDate && this.selectedToDate;
    },
  },
  data: function () {
    return {
      validationData: null,

      selectedFromDate: null,
      selectedToDate: null,

      tableDataType: {
        '#': 'string',
        'Doc No': 'string',
        'Doc Type': 'string',
        Details: 'string',
        Action: 'string',
      },

      validationHideColumns: ['DocTxnID'],

      lastRefreshed: null,

      fromDateErr: '',
      toDateErr: '',
    };
  },
  props: {},
  methods: {
    checkDateInputErr: function () {
      if (this.selectedFromDate == null && this.selectedToDate == null) return true;

      if (this.selectedFromDate != null && this.selectedToDate != null) {
        if (this.selectedFromDate.getTime() > this.selectedToDate.getTime()) {
          this.fromDateErr = 'Start Date cannot be greater than End Date';
          this.toDateErr = 'Start Date cannot be greater than End Date';
          return true;
        }
      }
      return false;
    },
    validateClicked: async function () {
      if (this.checkDateInputErr()) {
        this.$showAlert('error', 'Invalid Date Range', this.fromDateErr);
        return;
      }
      const startDateTime = new Date().formatString('yyyy-MM-dd HH:mm:ss');

      const formattedFromDate = this.selectedFromDate.formatString('yyyy-MM-dd');
      const formattedToDate = this.selectedToDate.formatString('yyyy-MM-dd');

      // Validation process
      this.validationData = [];
      this.$fullscreenLoading('Validating Accounts...');
      const result = await this.$apiCallV2('/Validation/ValidateFINGL', {
        txnstartdate: this.selectedFromDate ? formattedFromDate : '',
        txnenddate: this.selectedToDate ? formattedToDate : '',
      });

      const endDateTime = new Date().formatString('yyyy-MM-dd HH:mm:ss');

      if (result.length > 0) {
        result[0]['Details'] = 'Validation Started at ' + startDateTime;
        result[result.length - 1]['Details'] = 'Validation Completed at ' + endDateTime;
        this.validationData = result;

        for (const dataRow of this.validationData) {
          if (dataRow['Action'] == 'Requires Action') {
            dataRow['#'] =
              `<img style="height: 20px; width: 20px;" src="https://dsmlib.logistics.systems/Icons/error.png"> ${dataRow['#']}`;
          } else if (dataRow['Action'] == 'Solved') {
            dataRow['#'] =
              `<img style="height: 20px; width: 20px;" src="https://dsmlib.logistics.systems/Icons/GreenTick.png"> ${dataRow['#']}`;
          }
        }
      }
      this.lastRefreshed = endDateTime;
      this.$fullscreenLoading();
    },
    openClicked: async function (_btn, data) {
      const docType = data['Doc Type'];
      let docURL = '';

      switch (docType) {
        case 'IN': {
          // AR Invoice
          docURL = this.$router.resolve({
            path: `/Home/${this.$route.params['user']}/FINAR/Invoice`,
            query: {
              action: 'E',
              invno: data['Doc No'],
            },
          });
          break;
        }
        case 'DN': {
          // AR Debit Note
          docURL = this.$router.resolve({
            path: `/Home/${this.$route.params['user']}/FINAR/Debit%20Note`,
            query: {
              action: 'E',
              invno: data['Doc No'],
            },
          });
          break;
        }
        case 'CN': {
          // AR Credit Note
          docURL = this.$router.resolve({
            path: `/Home/${this.$route.params['user']}/FINAR/Credit%20Note`,
            query: {
              action: 'E',
              invno: data['Doc No'],
            },
          });
          break;
        }
        case 'RT': {
          // Receipt / Misc. Receipt
          const rtPath = await this.checkReceiptType(data['Doc No']) == 0 ? 'Receipt' : 'Misc%20Receipt';
          docURL = this.$router.resolve({
            path: `/Home/${this.$route.params['user']}/FINAR/${rtPath}`,
            query: {
              action: 'E',
              rtno: data['Doc No'],
            },
          });
          break;
        }
        case 'APIN': {
          // AP Invoice
          docURL = this.$router.resolve({
            path: `/Home/${this.$route.params['user']}/FINPayment/AP%20Invoice`,
            query: {
              action: 'E',
              apinvno: data['Doc No'],
            },
          });
          break;
        }
        case 'APCN': {
          // AP Credit Note / AP Debit Note
          const apPath = await this.checkAPTxnType(data['Doc No']) == 0 ? 'Debit' : 'Credit';
          docURL = this.$router.resolve({
            path: `/Home/${this.$route.params['user']}/FINPayment/AP%20${apPath}%20Note`,
            query: {
              action: 'E',
              apcn: data['Doc No'],
            },
          });
          break;
        }
        case 'PV': {
          // Payment
          docURL = this.$router.resolve({
            path: `/Home/${this.$route.params['user']}/FINPayment/Payment`,
            query: {
              action: 'E',
              docno: data['Doc No'],
            },
          });
          break;
        }
        default: {
          this.$showAlert('error', 'Invalid Selection', 'Please select a valid Transaction to view.');
          return;
        }
      }
      window.open(docURL.href, '_blank');
    },
    checkAPTxnType: async function (invno) {
      this.$fullscreenLoading('Checking AP Transaction Type...');
      let txnType = 0; // Credit ? 1 : 0
      const apDetails = 
        await this.$apiCallV2('/APInvoice/GetAPInvoiceDetails', { apinvno: invno, txntype: txnType });
      // API returns blank header if doc is Credit Note
      if (apDetails['AP'] == '')
        txnType = 1;
      this.$fullscreenLoading();
      return txnType;
    },
    checkReceiptType: async function (rtno) {
      this.$fullscreenLoading('Checking Receipt Type...');
      let rttype = 0;
      const rtDetails = 
        await this.$apiCallV2('/Receipt/GetReceiptDetails', { receiptno: rtno });
      // Transaction Type 'R' for misc receipt
      if (rtDetails['Receipt']['ReceiptHeader']['Transaction Type'] == 'R')
        rttype = 1; 
      this.$fullscreenLoading();
      return rttype;
    }
  },
  mounted() {
    const date = new Date();
    this.selectedFromDate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.selectedToDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.validation-main {
  font-size: 12px;
  width: 200px;
  height: 100%;
  padding: 10px 5px 10px 45px;
  display: flex;
  overflow: hidden;

  .content-container {
    height: 100%;
    width: 100%;
    display: flex;
    gap: 4px;
  }

  .left-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex-shrink: 0;
    resize: horizontal;
    overflow: auto;
    width: 260px;
    min-width: 170px;
    max-width: 30%;
  }

  .filter-container {
    border-radius: 4px;
    padding: 8px;
    padding-top: 4px;
    background-color: white;
    display: flex;
    flex-direction: column;
    gap: 2px;
    position: relative;
    min-height: 0;
  }

  .table-container {
    min-height: 0;
    flex-grow: 1;
    padding: 8px;
    padding-top: 0px;
    background-color: white;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 0;
  }
}
</style>